import React from 'react';

const SuccessInfo = () => (
  <div
    style={{
      backgroundColor: 'var(--orange)',
      padding: '10px',
      borderRadius: '10px',
    }}
  >
    <p style={{ color: 'white' }}>
      Seus créditos estarão disponíveis para validação dentro dos ônibus
      convencionais e METRO a partir de 2 horas após solicitação de recarga.
      <br />
      Para SUPLEMENTARES, a validação será possível 72 horas úteis após a
      aprovação da compra.
    </p>
  </div>
);
export default SuccessInfo;
